/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_DescriptionInputs */

const en_app_description = /** @type {(inputs: App_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find a trainer, book a session and train to your own plan. Open slots are visible without an account.`)
};

const pl_app_description = /** @type {(inputs: App_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znajdź trenera, zarezerwuj termin i trenuj według swojego planu. Wolne terminy widać bez zakładania konta.`)
};

/**
* | output |
* | --- |
* | "Find a trainer, book a session and train to your own plan. Open slots are visible without an account." |
*
* @param {App_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const app_description = /** @type {((inputs?: App_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_app_description(inputs)
	return en_app_description(inputs)
});